import * as React from "react";
import {
  Dialog,
  TextField,
  DialogContent,
  DialogTitle,
  ListItemText,
  List,
  ListItem,
  Typography,
  DialogActions,
  IconButton, Box
} from "@mui/material";
import { Close } from "@mui/icons-material"
import { ChangeEvent, useState } from "react";
import { capitalize } from "lodash";

export interface EntityIdentifierDialogProps {
  open: boolean;
  onClose: () => void;
  entityIdentifier: string[];
  entityName: string;
}

export default function EntityIdentifierDialog(
  props: EntityIdentifierDialogProps
) {
  const { onClose, open, entityIdentifier, entityName } = props;
  const [search, setSearchStr] = useState("");

  const handleClose = () => {
    setSearchStr("");
    onClose();
  };

  const onChangeSearch = (e: ChangeEvent<HTMLInputElement>) => {
    const { value } = e.target;
    setSearchStr(value);
  };

  const matchItemFunc = (item: string) => {
    const regex = new RegExp(search, "gi");
    if (item) {
      return item.match(regex);
    }
    return false;
  };

  return (
    <Dialog
      maxWidth="xs"
      fullWidth={true}
      scroll="paper"
      onClose={(event, reason) => {
        handleClose();
      }}
      open={open}
    >
      <DialogTitle>
        <Box display="flex" alignItems="center" justifyContent="space-between">
          <strong>
            List Updated {capitalize(entityName)}s
          </strong>
          <IconButton edge="end" color="inherit" onClick={handleClose} aria-label="close">
            <Close />
          </IconButton>
        </Box>
      </DialogTitle>
      <DialogContent dividers={true}>
        <TextField
          value={search}
          autoFocus
          size="small"
          id="search-entity"
          label="Search"
          type="text"
          fullWidth
          variant="standard"
          onChange={onChangeSearch}
        />
        <List>
          {Array.isArray(entityIdentifier) &&
            entityIdentifier.filter(matchItemFunc).map((item, index) => (
              <ListItem key={index} disableGutters>
                <ListItemText primary={item} />
              </ListItem>
            ))}
        </List>
      </DialogContent>
      <DialogActions>
        <Typography>
          <strong>Total:</strong>
        </Typography>
        <span className="mr-2">{entityIdentifier.length}</span>
      </DialogActions>
    </Dialog>
  );
}
